// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-context-menu {
  font-size: 14px;
  position: absolute;
  display: none;
  z-index: 9999;
  background-color: var(--background-color-1);
  padding: 4px;
  border-radius: 5px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--color-text-1);
}

.cesium-context-menu ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.cesium-context-menu li {
  padding: 8px 10px;
  cursor: pointer;
}

.cesium-context-menu li:hover {
  background-color: var(--color-hover-1);
}

.box-drag-element {
  position: absolute;
  border: 0.5px dashed rgba(21, 101, 175, 0.8);
  background-color: rgba(21, 101, 175, 0.2);
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/contextMenu.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,yCAAyC;EACzC,oBAAoB;AACtB","sourcesContent":[".cesium-context-menu {\r\n  font-size: 14px;\r\n  position: absolute;\r\n  display: none;\r\n  z-index: 9999;\r\n  background-color: var(--background-color-1);\r\n  padding: 4px;\r\n  border-radius: 5px;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  color: var(--color-text-1);\r\n}\r\n\r\n.cesium-context-menu ul {\r\n  margin: 0;\r\n  padding: 0;\r\n  list-style-type: none;\r\n}\r\n\r\n.cesium-context-menu li {\r\n  padding: 8px 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.cesium-context-menu li:hover {\r\n  background-color: var(--color-hover-1);\r\n}\r\n\r\n.box-drag-element {\r\n  position: absolute;\r\n  border: 0.5px dashed rgba(21, 101, 175, 0.8);\r\n  background-color: rgba(21, 101, 175, 0.2);\r\n  pointer-events: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
